import {createBrowserRouter, createRoutesFromElements, Route} from "react-router-dom";
import React from "react";
import MasterContainer from "../shared/components/container";
import RelatorioPremiacaoGeralPage from "../pages/backoffice/relatorios/geral";
import Login from "../pages/auth/login";
import Home from "../pages/backoffice/home";
import TruckDriversList from "../pages/backoffice/motoristas";
import CreateMotoristaPage from "../pages/backoffice/motoristas/create";
import EditMotoristaPage, {editMotoristaLoader} from "../pages/backoffice/motoristas/edit";
import ClientsListPage from "../pages/backoffice/clients";
import BusinessUnitListPage from "../pages/backoffice/bussiness-units";
import CreateBusinessUnitPage from "../pages/backoffice/bussiness-units/create";
import EditBusinessUnitPage, {editBusinessUnitLoader} from "../pages/backoffice/bussiness-units/edit";
import FleetList from "../pages/backoffice/fleets";
import CreateFleetPage from "../pages/backoffice/fleets/create";
import EditFleetPage, {editFleetLoader} from "../pages/backoffice/fleets/edit";
import BonusConfigsList from "../pages/backoffice/fleets/bonus-configs";
import CreateEngineLoadBonusConfigPage from "../pages/backoffice/fleets/bonus-configs/engine-load/create";
import CreateInertiaBonusConfigPage from "../pages/backoffice/fleets/bonus-configs/inertia/create";
import ClientDriversList from "../pages/backoffice/clients/drivers";
import FleetDriversList from "../pages/backoffice/fleets/drivers";
import PoliticaDePrivacidade from "../pages/auth/politica-de-privacidade";
import ClientDashboardPage from "../pages/backoffice/dashboard";
import CreateEngineLoadExceptionConfigPage from "../pages/backoffice/fleets/bonus-configs/engine-load-exception/create";
import VehicleTypePage from "../pages/torre/vehicle-type";
import FleetTypePage from "../pages/torre/fleet-type";
import OperationTypePage from "../pages/torre/operation-type";
import ReferenceGroupPage from "../pages/torre/reference-group";
import ReferencePage from "../pages/torre/reference";
import ProductPage from "../pages/torre/product";
import JustificationPage from "../pages/torre/justification";
import ProgrammingListPage from "../pages/backoffice/programming";
import CreateProgrammingPage from "../pages/backoffice/programming/create";
import EditProgrammingPage from "../pages/backoffice/programming/edit";
import RoutePage from "../pages/torre/route";
import TorrePage from "../pages/torre";
import ManagersListPage from "../pages/backoffice/managers";
import EditManagerPage, {editManagerLoader} from "../pages/backoffice/managers/edit";

export const managerRoutes = (profile: string, isLogged: boolean, username: string) => createBrowserRouter(createRoutesFromElements(<>
    <Route path="backoffice/relatorios/geral"
           element={<MasterContainer profile={profile} username={username}
                                     isLogged={isLogged}><RelatorioPremiacaoGeralPage/></MasterContainer>}/>

    <Route path="login" element={<Login/>}/>
    <Route path="home" element={<MasterContainer profile={profile} username={username}
                                                 isLogged={isLogged}><Home/></MasterContainer>}/>
    <Route path="/" element={<MasterContainer profile={profile} username={username}
                                              isLogged={isLogged}><Home/></MasterContainer>}/>
    <Route path="*" element={<MasterContainer profile={profile} username={username}
                                              isLogged={isLogged}><Home/></MasterContainer>}/>

    {/*//TODO:Conferir com o warley se o gestor poderá ver uma lista de motoristas já que alguns motoristas inicialmente não terão um cliente, então o gestor também poderá ve-los, a menos que adaptemos o sistema*/}
    <Route path="backoffice/motoristas"
           element={<MasterContainer profile={profile} username={username}
                                     isLogged={isLogged}><TruckDriversList/></MasterContainer>}/>

    <Route path="backoffice/motoristas/create" element={<MasterContainer profile={profile} username={username}
                                                                         isLogged={isLogged}><CreateMotoristaPage/></MasterContainer>}/>

    <Route
        path="backoffice/motoristas/edit/:id"
        element={<MasterContainer profile={profile} username={username}
                                  isLogged={isLogged}><EditMotoristaPage/></MasterContainer>}
        loader={editMotoristaLoader}/>

    <Route path="backoffice/managers"
           element={<MasterContainer profile={profile} username={username}
                                     isLogged={isLogged}><ManagersListPage/></MasterContainer>}/>

    <Route
        path="backoffice/managers/edit/:id"
        element={<MasterContainer profile={profile} username={username}
                                  isLogged={isLogged}><EditManagerPage/></MasterContainer>}
        loader={editManagerLoader}/>

    {/*//TODO:Conferir com o warley se o gestor poderá ver uma lista de clientes;*/}
    <Route path="backoffice/clients"
           element={<MasterContainer profile={profile} username={username}
                                     isLogged={isLogged}><ClientsListPage/></MasterContainer>}/>

    <Route path="backoffice/business-units"
           element={<MasterContainer profile={profile} username={username}
                                     isLogged={isLogged}><BusinessUnitListPage/></MasterContainer>}/>

    <Route path="backoffice/business-units/create" element={<MasterContainer profile={profile} username={username}
                                                                             isLogged={isLogged}><CreateBusinessUnitPage/></MasterContainer>}/>

    <Route
        path="backoffice/business-units/edit/:id"
        element={<MasterContainer profile={profile} username={username}
                                  isLogged={isLogged}><EditBusinessUnitPage/></MasterContainer>}
        loader={editBusinessUnitLoader}/>

    <Route path="backoffice/fleets"
           element={<MasterContainer profile={profile} username={username}
                                     isLogged={isLogged}><FleetList/></MasterContainer>}/>

    <Route path="backoffice/fleets/create" element={<MasterContainer profile={profile} username={username}
                                                                     isLogged={isLogged}><CreateFleetPage/></MasterContainer>}/>

    <Route
        path="backoffice/fleets/edit/:id"
        element={<MasterContainer profile={profile} username={username}
                                  isLogged={isLogged}><EditFleetPage/></MasterContainer>}
        loader={editFleetLoader}/>

    <Route path="backoffice/fleets/bonus-configs"
           element={<MasterContainer profile={profile} username={username}
                                     isLogged={isLogged}><BonusConfigsList/></MasterContainer>}/>

    <Route path="backoffice/fleets/bonus-configs/engine-load/create"
           element={<MasterContainer profile={profile} username={username}
                                     isLogged={isLogged}><CreateEngineLoadBonusConfigPage/></MasterContainer>}/>

    <Route path="backoffice/fleets/bonus-configs/engine-load/create"
           element={<MasterContainer profile={profile} username={username}
                                     isLogged={isLogged}><CreateEngineLoadExceptionConfigPage/></MasterContainer>}/>


    <Route path="backoffice/fleets/bonus-configs/inertia/create"
           element={<MasterContainer profile={profile} username={username}
                                     isLogged={isLogged}><CreateInertiaBonusConfigPage/></MasterContainer>}/>


    <Route path="backoffice/clients/drivers/"
           element={<MasterContainer profile={profile} username={username}
                                     isLogged={isLogged}><ClientDriversList/></MasterContainer>}/>


    <Route path="backoffice/fleets/:id/drivers/"
           element={<MasterContainer profile={profile} username={username}
                                     isLogged={isLogged}><FleetDriversList/></MasterContainer>}/>


    <Route path="backoffice/dashboard"
           element={<MasterContainer profile={profile} username={username}
                                     isLogged={isLogged}><ClientDashboardPage/></MasterContainer>}/>

    <Route
        path="politica-de-privacidade"
        element={<PoliticaDePrivacidade/>}/>

    <Route path="torre/vehicle-types"
           element={<MasterContainer profile={profile} username={username}
                                     isLogged={isLogged}><VehicleTypePage/></MasterContainer>}/>

    <Route path="torre/fleet-types"
           element={<MasterContainer profile={profile} username={username}
                                     isLogged={isLogged}><FleetTypePage/></MasterContainer>}/>

    <Route path="torre/operation-types"
           element={<MasterContainer profile={profile} username={username}
                                     isLogged={isLogged}><OperationTypePage/></MasterContainer>}/>

    <Route path="torre/reference-groups"
           element={<MasterContainer profile={profile} username={username}
                                     isLogged={isLogged}><ReferenceGroupPage/></MasterContainer>}/>

    <Route path="torre/references"
           element={<MasterContainer profile={profile} username={username}
                                     isLogged={isLogged}><ReferencePage/></MasterContainer>}/>

    <Route path="torre/products"
           element={<MasterContainer profile={profile} username={username}
                                     isLogged={isLogged}><ProductPage/></MasterContainer>}/>

    <Route path="torre/justifications"
           element={<MasterContainer profile={profile} username={username}
                                     isLogged={isLogged}><JustificationPage/></MasterContainer>}/>

    <Route path="torre/routes"
           element={<MasterContainer profile={profile} username={username}
                                     isLogged={isLogged}><RoutePage/></MasterContainer>}/>

    <Route path="torre/index.tsx"
           element={<MasterContainer profile={profile} username={username}
                                     isLogged={isLogged}><TorrePage/></MasterContainer>}/>

    {/*#region programming*/}
    <Route path="backoffice/programming"
           element={<MasterContainer profile={profile} username={username}
                                     isLogged={isLogged}><ProgrammingListPage/></MasterContainer>}/>

    <Route path="backoffice/programming/create"
           element={<MasterContainer profile={profile} username={username}
                                     isLogged={isLogged}><CreateProgrammingPage/></MasterContainer>}/>

    <Route path="backoffice/programming/edit/:id"
           element={<MasterContainer profile={profile} username={username}
                                     isLogged={isLogged}><EditProgrammingPage/></MasterContainer>}/>
    {/*#endregion*/}



</>));